import React from "react";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { BottomNavigation, BottomNavigationAction } from "@mui/material";
import { publicTheme } from "../layout/themes/public.theme";
import { Home, LibraryBooks } from "@mui/icons-material";

const useStyles = makeStyles(
    createStyles({
        bottomNav: {
            position: "fixed",
            bottom: 0,
            width: "100%",
            backgroundColor: publicTheme.palette.secondary.dark,
        },
    }),
);

type NavigationProps = {
    navIndex: number;
    changeNavIndex: (newIndex: number) => void;
};

export const Navigation = (props: NavigationProps): JSX.Element => {
    const classes = useStyles();
    return (
        <>
            <BottomNavigation
                value={props.navIndex}
                onChange={(event, newIndex) => {
                    props.changeNavIndex(newIndex);
                }}
                showLabels
                className={classes.bottomNav}
            >
                <BottomNavigationAction label="Home" icon={<Home />} />
                <BottomNavigationAction label="Collections" icon={<LibraryBooks />} />
            </BottomNavigation>
        </>
    );
};
